module.exports = __webpack_public_path__ + "static/media/mail.70852fc8.svg";